import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María G.',
  location: 'Houston, TX',
  text: 'Pensé que con ITIN no podía comprar. Esta guía me abrió los ojos y ahora estoy en proceso de pre-aprobación.'
}, {
  name: 'Carlos R.',
  location: 'Los Angeles, CA',
  text: 'Soy self-employed y no sabía qué documentos necesitaba. La guía me explicó todo paso a paso.'
}, {
  name: 'Ana P.',
  location: 'Miami, FL',
  text: 'Pagaba $2,200 de renta. Gracias a la información de la guía, ahora pago $1,800 de mortgage por MI casa.'
}];
export function TrustSection() {
  return <section className="py-24 bg-dark relative border-y border-white/5 overflow-hidden pt-[10px] pb-[10px]" data-id="element-113">
      {/* Decorative Background Image */}
      <div className="absolute inset-0 opacity-5 pointer-events-none mix-blend-luminosity" data-id="element-114">
        <img src="https://cdn.magicpatterns.com/uploads/q9cgtWCU8XFDDmph6mo9jS/a7.jpg" alt="Background pattern" className="w-full h-full object-cover" data-id="element-115" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-117">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl mb-6" data-id="element-118">
            Información Clara, en Español, Sin Tecnicismos
          </h2>
          <p className="text-muted text-lg" data-id="element-119">
            Únete a cientos de familias latinas que ya están tomando el control
            de su futuro financiero.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 mb-12 gap-[20px]" data-id="element-120">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-dark-card border border-white/5 rounded-xl p-8 relative pt-[20px] pb-[20px]" data-id="element-121">
              <div className="flex gap-1 mb-6" data-id="element-122">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-123" />)}
              </div>
              <p className="text-white/90 text-lg leading-relaxed mb-8 italic" data-id="element-124">
                "{testimonial.text}"
              </p>
              <div className="mt-auto" data-id="element-125">
                <p className="font-semibold text-white" data-id="element-126">{testimonial.name}</p>
                <p className="text-gold text-sm" data-id="element-127">{testimonial.location}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-muted/60 text-sm max-w-2xl mx-auto" data-id="element-128">
          Nota: Los resultados pueden variar. Esta guía es educativa y no
          garantiza resultados específicos ni la aprobación de un préstamo
          hipotecario.
        </motion.p>
      </div>
    </section>;
}